const Header = ( $ ) => {

	const burger = $( '.burger-menu' );
	const menuWrapper = $( '.menu-wrapper' );
	const body = $( 'body' );
	const close = $( '.close' );
	const header = $( 'header' );
	
	burger.click( function() {
		menuWrapper.toggleClass( 'open' );
		body.toggleClass( 'open-menu' );
	} );

	close.click( function() {
		menuWrapper.toggleClass( 'open' );
		body.toggleClass( 'open-menu' );
	} );

	$( document ).mouseup( function( e ) {
		var folder = menuWrapper;
		if ( ! folder.is( e.target ) && folder.has( e.target ).length === 0 ) {
			folder.removeClass( 'open' );
			body.removeClass( 'open-menu' );
		}
	} );

	$( document ).on( 'scroll', function() {
		if ( $( document ).scrollTop() ) {
			header.addClass( 'fixed-header' );
		} else {
			header.removeClass( 'fixed-header' );
		}
	} );

	$(function() {
		if (navigator.userAgent.match(/safari/i) &&
			!navigator.userAgent.match(/chrome|crios|fxios|edg|opr/i)) {
			$('body').addClass('safari');
		}
	});
};

export default ( ( $ ) => $( Header ) )( jQuery );
